@if (v2) {
	<button type="button" class="asset-v2-trigger" (click)="selectAsset()">
		@if (asset != null) {
			<span class="asset-v2-value">{{ asset.name }}</span>
		} @else {
			<span class="asset-v2-placeholder">{{ "ASSIGNMENT__TAP_TO_SELECT" | transloco }}</span>
		}
		<span class="material-symbols-outlined" aria-hidden="true">chevron_right</span>
	</button>
} @else {
	<ion-item (click)="selectAsset()" lines="full">
		<ion-icon name="cube-outline" slot="start"></ion-icon>
		<ion-label position="stacked">{{ "ASSIGNMENT__ASSET" | transloco }}</ion-label>

		@if (asset != null) {
			<div class="asset">{{ asset.name }}</div>
		} @else {
			<div class="asset placeholder">{{ "ASSIGNMENT__TAP_TO_SELECT" | transloco }}</div>
		}
	</ion-item>
}
